import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AppFilter } from '@app/shared/models';
import {
  ComponentModalConfig,
  ModalSize,
  SuiModal,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { WorkFlowService } from '../../services/workflow.service';

import { AddNewWorkflowGroupModal } from '../add-new-workflow-group/add-new-workflow-group.component';

interface IAddConfigModalContext {
  title: any;
  workflowTypeId: string;
  organizationUnitId: string;
}
interface Unit {
  organizationUnitId: string;
  organizationId: string;
  unitName: string;
  actionAdditionalDetails: string;
  dateCreated: string;
  dateModified: string;
  createdBy: string;
  modifiedBy: string;
}

@Component({
  selector: 'app-new-workflow',
  templateUrl: './new-workflow.component.html',
  styleUrls: ['./new-workflow.component.scss'],
})
export class NewWorkflowComponent implements OnInit {
  filter: AppFilter;
  activeOptions = [
    {
      optionId: true,
      optionName: 'ACTIVE',
    },
    {
      optionId: false,
      optionName: 'INACTIVE',
    },
  ];
  success;
  error;
  pending;
  workGroupsList: Array<any> = [];
  workFlowTypeList = [
    {
      optionId: 'INVOICE_APPROVAL',
      optionName: 'INVOICE APPROVAL',
    },
    {
      optionId: 'PAYMENT_APPROVAL',
      optionName: 'PAYMENT APPROVAL',
    },
    {
      optionId: 'GATEWAY_PAYMENT_APPROVAL',
      optionName: 'GATEWAY PAYMENT APPROVAL',
    },
    {
      optionId: 'RECEIPT_APPROVAL',
      optionName: 'RECEIPT APPROVAL',
    },
  ];
  organizationId = localStorage.getItem('organizationId');

  organizationUnits =
    localStorage.getItem('userData') != null
      ? JSON.parse(localStorage.getItem('userData'))['appUser'][
          'organizationUnits'
        ]
      : [];
  selectedWorkflowTypeId;
  workForm: FormGroup = new FormGroup({
    active: new FormControl(true, [Validators.required]),
    workFlowType: new FormControl('', [Validators.required]),
    firstDescription: new FormControl('', [Validators.required]),
  });

  formSubmitAttempt;

  constructor(
    public modal: SuiModal<IAddConfigModalContext, void, void>,
    private workflowService: WorkFlowService,
    private modalService: SuiModalService,
    private fb: FormBuilder
  ) {
    this.filter = new AppFilter({ sidx: 'dateCreated', sord: 'desc' });
    this.selectedWorkflowTypeId = modal.context.workflowTypeId;
    this.workForm['value']['workFlowType'] = modal.context.workflowTypeId;
    this.unitFilter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      rows: 1000,
      sord: 'desc',
    });
  }

  close() {
    this.success = null;
    this.error = null;
  }

  removeWorkFlowGroup(i): void {
    this.workGroupsList.splice(i, 1);
    this.workflowService.deleteWorkFlowGroup(i);
  }

  isFieldValid(field: string) {
    return (
      (!this.workForm.get(field).valid && this.workForm.get(field).touched) ||
      (this.workForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  createWorkFlowGroup(): void {
    this.modalService
      .open(
        new AddNewWorkflowGroupModal('New Workflow Group', {}, false)
      )
      .onApprove((eq) => {
        this.workGroupsList.push(eq);
      });
  }

  save() {
    if (this.workForm.valid) {
      this.pending = true;
      this.workflowService
        .createWorkflow({
          //organizationUnitId: this.organizationId,
          organizationUnitId: "ncc",
          body: {
            ...this.workForm.value,
            workFlowGroups: this.workGroupsList,
          },
        })
        .subscribe(
          (e) => {
            this.pending = false;
            this.success = 'Workflow was created successfully';
            setTimeout(() => {
              this.modal.approve();
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  editWorkFlowGroup(i) {
    this.modalService
      .open(
        new AddNewWorkflowGroupModal(
          'New Workflow Group',
          this.workGroupsList[i],
          true
        )
      )
      .onApprove((eq) => {
        this.workGroupsList.splice(i, 1);
        this.workGroupsList.push(eq);
      });
  }

  ngOnInit(): void {
    // this.getOrganizations();
  }
  unitFilter: AppFilter;
  selectedUnit;
  units;
  getOrganizations() {
    this.workflowService
      .getAllOrganizationUnits({
        organizationId: this.organizationId,
        params: this.unitFilter,
      })
      .subscribe(
        (e) => {
          this.units = e.rows as Array<Unit>;
          if (this.units.length > 0) {
            this.selectedUnit = this.units[0];
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }
}

export interface WorkflowGroup {
  name: string;
  description: string;
  appUserIds: Array<string>;
}

export class NewWorkflowModal extends ComponentModalConfig<
  IAddConfigModalContext,
  void,
  void
> {
  constructor(
    title: string,
    workflowTypeId: string,
    organizationUnitId: string,
    isEdit: boolean = false,
    size: ModalSize = ModalSize.Mini
  ) {
    super(NewWorkflowComponent, {
      title,
      workflowTypeId,
      organizationUnitId,
    });
    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
    this.transition = 'slide left';
  }
}
